module.exports = __webpack_public_path__ + "static/media/cancer.3c788205.svg";